import CaptionText from 'components/common/CaptionText';
import { Spin } from 'antd';
import useTranslation from 'hooks/use-translation';

export default function InstitutionCaption(): JSX.Element {
  const translation = useTranslation();

  if (!translation) {
    return <Spin />;
  }
  return (
    <CaptionText className='institution-label' aria-hidden='true'>
      {translation.institution}
    </CaptionText>
  );
}
